import { Container, Carousel } from "@peracto/peracto-blocks";
import { default as Embed } from "./Embed";
import { default as Accordion } from "./Accordion";

export default {
    plugins: {
        content: [Accordion, Carousel, Embed],
        layout: [Container],
    },
};
